export default __webpack_public_path__ + "static/media/190629_190332_IMG_E2674.70aa1a0f.jpg";